import { GridToolbar, GRID_CHECKBOX_SELECTION_FIELD } from '@mui/x-data-grid-pro';

import { COLUMNS } from './constants';
import { CustomColumnMenu, CustomMenuIcon, DATAGRID_COMMON_STYLE } from '@commons/utils/dataGrid';

// See https://mui.com/x/react-data-grid/style/#using-the-sx-prop for reference
const DATAGRID_STYLE = ({ hasEmptyState = false }) => ({
  ...DATAGRID_COMMON_STYLE,
  // Additional pagination styling
  '& .MuiTablePagination-select': {
    fontSize: '12px',
    fontWeight: '400',
    '&:focus': {
      backgroundColor: 'rgba(0, 234, 131, 0.04)',
    },
  },
  '& .MuiTablePagination-selectLabel': {
    fontSize: '12px',
    fontWeight: '400',
    paddingTop: '4px',
  },
  '& .MuiTablePagination-displayedRows': {
    fontSize: '12px',
    fontWeight: '400',
    paddingTop: '6px',
  },
  '& .MuiTablePagination-actions': {
    paddingBottom: '4px',
  },
  ...(hasEmptyState && {
    // Override virtualScroller minHeight for empty state
    '& .MuiDataGrid-virtualScroller': {
      minHeight: '400px',
    },
    // More specific styling for when empty state is shown
    '& .MuiDataGrid-virtualScroller--overflowX': {
      minHeight: '400px',
    },
    '& .MuiDataGrid-virtualScrollerContent--overflowed': {
      minHeight: '400px',
    },
    // Alternative: Set height for empty state container
    '& .MuiDataGrid-overlay': {
      height: '400px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
});

// See https://mui.com/x/api/data-grid/data-grid-pro/ for reference
const DATAGRID_OTHER_PROPS = {
  autosizeOnMount: true,
  disableColumnResize: false,
  disableColumnSelector: true,
  disableDensitySelector: true,
  disableRowSelectionOnClick: true,
  ignoreDiacritics: true,
  showCellVerticalBorder: false,
  showColumnVerticalBorder: false,
  pageSizeOptions: [10, 25, 50],
};

export const DATAGRID_INITIAL_STATE = {
  pinnedColumns: {
    left: [GRID_CHECKBOX_SELECTION_FIELD, COLUMNS.NAME, COLUMNS.CATEGORY],
    right: [COLUMNS.TOTAL],
  },
  columns: {
    columnVisibilityModel: {
      sku: false,
      launchDate: false,
      endDate: false,
      subCategory: false,
    },
  },
  sorting: {
    sortModel: [
      { field: COLUMNS.NAME, sort: 'asc' },
      { field: COLUMNS.CATEGORY, sort: 'asc' },
    ],
  },
  filter: {
    filterModel: {
      items: [
        { columnField: COLUMNS.NAME, operatorValue: 'contains', value: '' },
        { columnField: COLUMNS.SKU, operatorValue: 'contains', value: '' },
        { columnField: COLUMNS.LAUNCH_DATE, operatorValue: 'contains', value: '' },
        { columnField: COLUMNS.END_DATE, operatorValue: 'contains', value: '' },
      ],
    },
  },
  pagination: {
    paginationModel: {
      pageSize: 10,
    },
  },
};

export const DATAGRID_SLOTS = {
  toolbar: GridToolbar,
  columnMenu: (props) => CustomColumnMenu(props, [COLUMNS.NAME, COLUMNS.CATEGORY, COLUMNS.TOTAL]),
  columnMenuIcon: CustomMenuIcon,
};

const DATAGRID_SLOT_PROPS = {
  toolbar: {
    showQuickFilter: true,
    printOptions: { disableToolbarButton: true },
    csvOptions: { disableToolbarButton: true },
  },
};

export const COMMON_DATAGRID_PROPS = ({ hasEmptyState = false }) => ({
  initialState: DATAGRID_INITIAL_STATE,
  sx: DATAGRID_STYLE({ hasEmptyState }),
  slotProps: DATAGRID_SLOT_PROPS,
  ...DATAGRID_OTHER_PROPS,
});
